import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

import Icon from '../../../Icons'

const HomeTab = () => {
  const { t } = useTranslation(['chat'])
  const handleOpenEmail = (recipientEmail, subject) => {
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}`
    window.location.href = mailtoLink
  }

  const handleOpenHtml = (link) => {
    window.open(link, '_blank')
  }

  return (
    <div className="home-tab">
      <div className="tab-navbar">
        <div className="top-side">
          {/*<img className="chitown-logo" src={logo} />*/}
          <img
            className="chitown-logo"
            src="/images/logo/elevateos-logo-wide-white.svg"
            alt={ELEVATEOS_LOGO_ALT}
          />
        </div>
        <div className="bottom-side">
          <div>{t('chat:homeTab.welcome')}</div>
          <div>{t('chat:homeTab.howCanWeHelp')}</div>
        </div>
      </div>
      <div className="tab-body">
        <div
          className="redirect-option"
          onClick={() => handleOpenHtml('https://help.elevateos.com')}
        >
          <div className="option-content">
            <Icon
              icon="notebookSearch"
              viewBox="-4 0 24 24"
              svgProps={{
                stroke: '#282828',
                strokeWidth: '1.44',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
            />
            <span>{t('chat:homeTab.visitKnowledgeCenter')}</span>
          </div>
          <Icon icon="arrow" viewBox="0 2 16 16" fill="#B5B4B4" />
        </div>
        <div
          className="redirect-option"
          onClick={() =>
            handleOpenHtml('https://airtable.com/app1cfo7jyYnvBIrg/pagvjg5qzidZglLIx/form')
          }
        >
          <div className="option-content">
            <Icon
              icon="diamond"
              viewBox="-2 0 24 24"
              svgProps={{
                stroke: '#282828',
                strokeWidth: '1.44',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
              }}
            />
            <span>{t('chat:homeTab.requestFeature')}</span>
          </div>
          <Icon icon="arrow" viewBox="0 2 16 16" fill="#B5B4B4" />
        </div>
        <div className="info-tip">
          <Icon icon="pendingMessage" viewBox="0 0 24 24" />
          <div>
            {t('chat:homeTab.reportIssue')}{' '}
            <span
              onClick={() =>
                handleOpenEmail(
                  t('chat:homeTab.reportIssueEmail'),
                  t('chat:homeTab.reportIssueSubject'),
                )
              }
            >
              {t('chat:homeTab.reportIssueEmail')}
            </span>
            .
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeTab
